module.exports = __webpack_public_path__ + "static/media/card1.135bc65e.png";